import './trailingSlash.js'
import './pricing.css'
import { initSiteHeader } from './siteHeader'
import { initSiteFooter } from './siteFooter'

initSiteHeader()
initSiteFooter()
